import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import './text.less';
import {
  DesktopOnly,
  MobileOnly,
  ContentfulRichText,
} from '../../../common/components';

const Text = ({ text, textAlign }) => {
  const className = useClassName('ModularText');
  const containerExtraClasses = [];

  if (text.titleType) containerExtraClasses.push(text.titleType);
  if (text.bold) containerExtraClasses.push('bold');
  if (text.italic) containerExtraClasses.push('italic');
  if (text.underline) containerExtraClasses.push('underline');
  if (text.whiteLink) containerExtraClasses.push('white-link');
  if (textAlign) containerExtraClasses.push(`text-align-${textAlign}`);

  return (
    <>
      <DesktopOnly
        className={className(['container', ...containerExtraClasses])}
        style={{
          color: text.color,
          fontSize: text.fontSize,
          fontWeight: text.fontWeight,
        }}>
        {text.richTextBody ? (
          <ContentfulRichText field={text.richTextBody} />
        ) : (
          text.body
        )}
      </DesktopOnly>
      <MobileOnly
        className={className(['container', ...containerExtraClasses])}
        style={{
          color: text.color,
          fontSize: text.mobileFontSize || text.fontSize,
          fontWeight: text.fontWeight,
        }}>
        {text.richTextBody ? (
          <ContentfulRichText field={text.richTextBody} />
        ) : (
          text.body
        )}
      </MobileOnly>
    </>
  );
};

Text.propTypes = {
  text: PropTypes.object.isRequired,
  textAlign: PropTypes.string,
};

export default Text;
